(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
window.PEWNIAKI_ANALIZA = (function () {
    // Te same koszyki i ta sama formula co w Twigu wyzej — obie drogi daja te same liczby.
    var KOSZYKI = [[0, 0, '0'], [1, 1, '1'], [2, 2, '2'], [3, 3, '3'], [4, 5, '4–5'], [6, 8, '6–8'], [9, 12, '9–12'], [13, 20, '13–20'], [21, null, '21+']];
    var f1 = function (v) { return v == null ? '—' : (Math.round(v * 10) / 10).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
    var f3 = function (v) { return v == null ? '—' : (Math.round(v * 1000) / 1000).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
    var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    var znak = function (v) { return (v >= 0 ? '+' : '−') + f1(Math.abs(v)); };

    function licz(o, model) {
        var hist = o.pula || {}, zak = o.zakonczonych || 0, N = o.losowan || 0;
        var p = (model && model.p != null) ? model.p : null;
        var oczek = (model && model.oczekiwany_gap != null) ? model.oczekiwany_gap : (p != null && p > 0 ? (1 - p) / p : null);
        var klucze = Object.keys(hist).map(Number).sort(function (a, b) { return a - b; });
        var maDane = !o.powod && klucze.length > 0 && zak > 0;
        var sumaG = 0, skum = 0, mediana = null;
        klucze.forEach(function (g) { sumaG += g * hist[g]; skum += hist[g]; if (mediana == null && skum * 2 >= zak) { mediana = g; } });
        var wiersze = [], odch = null;
        KOSZYKI.forEach(function (kosz) {
            var od = kosz[0], kres = kosz[1], obs = 0;
            klucze.forEach(function (g) { if (g >= od && (kres == null || g <= kres)) { obs += hist[g]; } });
            var pct = maDane ? obs * 100 / zak : null;
            var pctModel = p != null ? (kres == null ? Math.pow(1 - p, od) : Math.pow(1 - p, od) - Math.pow(1 - p, kres + 1)) * 100 : null;
            var roz = (pct != null && pctModel != null) ? pct - pctModel : null;
            var w = { etykieta: kosz[2], obs: obs, pct: pct, pctModel: pctModel, roz: roz };
            if (roz != null && (odch == null || Math.abs(roz) > Math.abs(odch.roz))) { odch = w; }
            wiersze.push(w);
        });
        return { N: N, zak: zak, maDane: maDane, p: p, oczek: oczek,
                 srednia: maDane ? sumaG / zak : null, mediana: maDane ? mediana : null,
                 najdluzsza: maDane ? klucze[klucze.length - 1] : null, wiersze: wiersze, odch: odch };
    }

    return {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[0] + '/analizy/przerwy.json',
        wersja: __pewniaki_inline_cfg[1],
        lata:   null,
        pula:   JSON.parse(String(__pewniaki_inline_cfg[2])),
        typuje: JSON.parse(String(__pewniaki_inline_cfg[3])),
        wnioski: function (o, klucz, dane) {
            // Napisy ze slownika: te same klucze, co w Twigu wyzej (daro, 19.09.2026)
            var T = {
              zd:    __pewniaki_inline_cfg[4],
              model: __pewniaki_inline_cfg[5],
              brakM: __pewniaki_inline_cfg[6],
              odch:  __pewniaki_inline_cfg[7],
              najd:  __pewniaki_inline_cfg[8],
              med:   __pewniaki_inline_cfg[9],
              brakZ: __pewniaki_inline_cfg[10],
              brakD: __pewniaki_inline_cfg[11]
            };
            if (!o) { return [T.brakD]; }
            var s = licz(o, (dane && dane.model) || {}), pkt = [];
            if (s.maDane && s.srednia != null) {
                var zd = T.zd.replace('%1', tys(s.N)).replace('%2', tys(s.zak)).replace('%3', f1(s.srednia));
                zd += s.oczek != null
                    ? T.model.replace('%1', f1(s.oczek)).replace('%2', f1(Math.abs(s.srednia - s.oczek)))
                    : T.brakM;
                pkt.push(zd);
            }
            if (s.maDane && s.odch) {
                pkt.push(T.odch.replace('%1', s.odch.etykieta).replace('%2', f1(s.odch.pct)).replace('%3', f1(s.odch.pctModel)).replace('%4', znak(s.odch.roz)));
            }
            if (s.maDane && s.najdluzsza != null) {
                pkt.push(T.najd.replace('%1', tys(s.najdluzsza)).replace('%2', s.mediana != null ? T.med.replace('%1', tys(s.mediana)) : '').replace('%3', tys(s.N)));
            }
            return pkt.length ? pkt : [T.brakZ];
        },
        render: function (okno, klucz, dane) {
            var q = function (sel) { return document.querySelector(sel); };
            var sekcja = q('[data-przerwy]');
            if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
            if (sekcja) { sekcja.hidden = false; }
            var s = licz(okno, (dane && dane.model) || {});
            q('[data-przerwy-n]').textContent = tys(s.N);
            q('[data-przerwy-zak]').textContent = tys(s.zak);
            q('[data-przerwy-srednia]').textContent = f1(s.srednia);
            q('[data-przerwy-mediana]').textContent = s.mediana != null ? tys(s.mediana) : '—';
            q('[data-przerwy-najdluzsza]').textContent = s.najdluzsza != null ? tys(s.najdluzsza) : '—';
            q('[data-przerwy-tabela] tbody').innerHTML = s.wiersze.map(function (w) {
                return '<tr><td class="liczbowa">' + w.etykieta + '</td><td class="liczbowa">' + tys(w.obs) + '</td><td class="liczbowa">'
                     + (w.pct != null ? f1(w.pct) + '%' : '—') + '</td><td class="liczbowa">'
                     + (w.pctModel != null ? f1(w.pctModel) + '%' : '—') + '</td><td class="liczbowa">'
                     + (w.roz != null ? znak(w.roz) : '—') + '</td></tr>';
            }).join('');
            if (window.PEWNIAKI_PRZERWY_WYKRES) window.PEWNIAKI_PRZERWY_WYKRES(q('[data-przerwy-chart]'), s.wiersze, s.N, s.zak);
        }
    };
})();
})();
